<!-- TelaExtraiDadosUsuario.svelte -->
<script>
    import InsereDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    import {
        ItemInserir,
        Tipo,
        generateCreateTableSQL,
    } from "../../Classes/ItemInserir.js";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import Constantes from "../../Classes/Constantes";
    import { permissaoUsuario } from "../../Classes/Stores";
    import { onMount } from "svelte";

    export let params;
    let id =params;
    //$: id1 =$params.id ;
    //const { id } = params.state;
    const apiInsercao = "inserir.php";
    const apiConsultaEdicao = "consultas.php";
    const apiEdicao = "editar.php";
    const query_code_inserir = "inserir_campeonatos";
    const query_code_editar = "editar";
    const query_code_apagar = "apagar";
    const query_code_carregar_edicao = "carrega_dados";
    const navegar_para_pos_edicao = Constantes.tela_montar_campeonatos;
    const tabela = "campeonatos";

    let itens = [
        

        new ItemInserir({
            rotulo: "Nome do Campeonato",
            nomeColuna: "nome_campeonato",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Data Inicial",
            nomeColuna: "data_inicial",
            tamanho: 10,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Data Final",
            nomeColuna: "data_final",
            tamanho: 10,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Data de Início da Inscrição",
            nomeColuna: "data_inicio_inscricao",
            tamanho: 10,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Data de Fim da Inscrição",
            nomeColuna: "data_fim_inscricao",
            tamanho: 10,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Comportamento Pós Encerrado",
            nomeColuna: "comportamento_pos_encerrado",
            tamanho: 5,
            tipo: Tipo.NUMERO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "URL da Imagem",
            nomeColuna: "imageUrl",
            tamanho: 255,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Descrição",
            nomeColuna: "descricao",
            tamanho: 500,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Texto de Destaque",
            nomeColuna: "textinho_destaque",
            tamanho: 30,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Texto do Botão",
            nomeColuna: "texto_botao",
            tamanho: 30,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Botão Habilitado",
            nomeColuna: "botao_habilitado",
            tamanho: 5,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                nome_coluna_saida: "botao_habilitado",
                filtravel: true,
                itens: [0, 1, 2],
            },
        }),
        new ItemInserir({
            rotulo: "Publicar",
            nomeColuna: "publicar",
            tamanho: 5,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                nome_coluna_saida: "publicar",
                filtravel: true,
                itens: [0, 1],
            },
        }),
        new ItemInserir({
            rotulo: "Título Seção 1",
            nomeColuna: "titulo_secao1",
            tamanho: 200,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Texto Seção 1",
            nomeColuna: "texto_secao1",
            tamanho: 500,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Título Seção 2",
            nomeColuna: "titulo_secao2",
            tamanho: 200,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Texto Seção 2",
            nomeColuna: "texto_secao2",
            tamanho: 500,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Título Seção 3",
            nomeColuna: "titulo_secao3",
            tamanho: 200,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Texto Seção 3",
            nomeColuna: "texto_secao3",
            tamanho: 500,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Quando",
            nomeColuna: "quando",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Onde",
            nomeColuna: "onde",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Recebe Pix",
            nomeColuna: "recebe_pix",
            tamanho: 5,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                nome_coluna_saida: "recebe_pix",
                filtravel: true,
                itens: [0, 1],
            },
        }),
        new ItemInserir({
            rotulo: "Recebe Boleto",
            nomeColuna: "recebe_boleto",
            tamanho: 5,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                nome_coluna_saida: "recebe_boleto",
                filtravel: true,
                itens: [0, 1],
            },
        }),
        new ItemInserir({
            rotulo: "Recebe Cartão",
            nomeColuna: "recebe_cartao",
            tamanho: 5,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                nome_coluna_saida: "recebe_cartao",
                filtravel: true,
                itens: [0, 1],
            },
        }),
        new ItemInserir({
            rotulo: "Limite de Inscritos",
            nomeColuna: "limite_inscritos",
            tamanho: 10,
            tipo: Tipo.NUMERO,
            obrigatorio: true,
        }),
        
    ];


onMount(()=>{
        if (id) {
            itens = itens.slice(0, -1);
        }
    });
    //console.log(generateCreateTableSQL("tabela",itens));
    //só precisa configurar acima disto
</script>

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_montar_campeonatos)}
    <div class="espacar">
        {#if id}
            <AlteraDadosBasico
                {id}
                {apiEdicao}
                {apiConsultaEdicao}
                {itens}
                {query_code_carregar_edicao}
                {query_code_editar}
                {query_code_apagar}
                {tabela}
                navegar_para={navegar_para_pos_edicao}
            />
        {:else}
            <InsereDadosBasico
                api={apiInsercao}
                {itens}
                {query_code_inserir}
                {tabela}
            />
        {/if}
    </div>
     <br />
    <br />
    <br />
    <br />
{:else}
    <br />
    <br />
    <br />
    <br />
    <br />
    <h1>Sem permissão</h1>
{/if}

<style>
    .espacar {
        margin-bottom: 3em;
    }
</style>
